import styled from 'styled-components';

const FulfillmentChipsStyle = styled.div`
	--distanceBetweenButtons: var(--sp1x);
	--sizeIconDesktop: var(--sp2-5x);
	--paddingBetweenButtons: var(--sp1-5x) var(--sp2-5x);
	--borderRadius: var(--sp4x);
	--distanceButtons: var(--sp1x);
	--sizeText: 18px;

	display: flex;
	gap: var(--distanceButtons);

	&.is-single-chip {
		width: fit-content;
		margin: 0 auto;
	}

	.fulfillment-type-btn {
		flex-shrink: 0;
	}

	.fulfillment-type-btn,
	.fulfillment-location-chip {
		background-color: var(--mainColor);
		display: flex;
		justify-content: center;
		align-items: center;
		gap: var(--distanceBetweenButtons);
		padding: var(--paddingBetweenButtons);
		border-radius: var(--borderRadius);
		cursor: pointer;
	}

	.fulfillment-location-chip {
		min-width: 0;
		flex: 1;
		max-width: 100%;
		overflow: hidden;
	}

	.fulfillment-pin,
	.fulfillment-chip-separator {
		flex-shrink: 0;
	}

	.fulfillment-chip-separator {
		width: 2px;
		height: 100%;
		background-color: var(--neutral300);
		border-radius: var(--borderRadius);
	}

	.icon-desktop {
		font-size: var(--sizeIconDesktop);

		&.arrow-right {
			transform: rotate(90deg);
		}
	}

	.text {
		font-size: var(--sizeText);
		line-height: 1;

		&.fulfillment-chip-location {
			flex: 0 1 auto;
			min-width: 0;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		&.fulfillment-chip-time {
			flex: 1 0 auto;
			white-space: nowrap;
			text-align: left;
		}
	}

	.fulfillment-pin {
		// transform: translateY(-2px);
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--sizeText: var(--sp2x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		.fulfillment-type-btn {
			aspect-ratio: 1/1;
			background-color: transparent;
			padding: 0;

			i {
				color: var(--mainColor);
				font-size: var(--sizeIconDesktop);
			}
		}
	}
`;

export default FulfillmentChipsStyle;
